import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "bootstrap";
// import jsCookie from 'js-cookie'
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import tool from "./cookie";
Vue.prototype.tool = tool;

// Axios 配置
import axios from "axios";
Vue.prototype.$axios = axios;
import QS from "qs";
Vue.prototype.qs = QS;

Vue.prototype.$checkPhone = function(phone) {
  if (!/^1[3456789]\d{9}$/.test(phone)) {
    this.$message.error("请填写正确的手机号");
    return false;
  }
  return true;
};

import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);

import websocket from "./websocket";
Vue.prototype.$websocket = websocket;

// 创建一个axios实例
// Axios 配置
Vue.config.productionTip = false;
Vue.use(ElementUI);

// 创建事件总线   就相当于创建了一个新的vue实例
const bus = new Vue();
// 把bus挂载到了Vue的原型上, 保证所有的组件都能通过 this.$bus访问到事件总线
Vue.prototype.$bus = bus;

new Vue({
  router,
  store,

  render: (h) => h(App),
}).$mount("#app");
